<template>
  <div class="disponibiliteSemaine">
    <div
      v-for="(echLigne, index) in echeanciers"
      :key="index" class="disponibilite"
      :class='[
          {"has-background-white": echLigne.montant > 0},
          {"is-cursor-pointer": echLigne.avecFacturation}
        ]'
        :style="echLigne.style">
      <div
        v-if="echLigne.montant > 0"
        @click="actionOnClick(echLigne)"
        class="shape">
        <div class="content is-size-9">
          {{ formatDevise(echLigne.montant) }}
        </div>
      </div>
      <div v-else class="shape">
        <div class="content"> --- </div>
      </div>
    </div>
    <b-modal
      v-model="afficherListeEcheancier"
      has-modal-card
      class="modal">
      <liste-echeanciers-ligne
        :echeanciers="echeanciersSelected"
        :ligneCommande="data"
        @close="afficherListeEcheancier = false">
      </liste-echeanciers-ligne>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import { formatDevise } from '@/services/general/filters/formatDevise';
import { calculateStyleCelluleEcheancierLigne } from '@/services/planningReseauTempo/calculateStyleCelluleEtatObtenu';
import { getEcheaciersLigneByDate } from '@/services/achat/marche/planningVentesMarche';
import ListeEcheanciersLigne from '@/components/achat/marche/ventesMarche/p_listeEcheanciersLigne';

const Marche = createNamespacedHelpers('marche');

export default {
  name: 'PlanningVentesMarche',
  props: {
    data: Object,
  },
  components: {
    ListeEcheanciersLigne,
  },
  data() {
    return {
      afficherListeEcheancier: false,
      echeanciersSelected: [],
    };
  },
  computed: {
    ...Marche.mapGetters({
      criteresRecherche: 'criteresRechercheVentesMarche',
    }),
    echeanciers() {
      const { dateDebut, dateFin } = this.criteresRecherche.datesEcheance;
      const startMonth = moment(dateDebut).startOf('month');
      const values = [{ date: moment(startMonth) }];
      startMonth.add(1, 'months');
      while (startMonth.isBefore(dateFin)) {
        values.push({ date: moment(startMonth) });
        startMonth.add(1, 'months');
      }
      return values.map(el => {
        const echs = getEcheaciersLigneByDate(this.data.echeanciersLigne, el.date);
        return {
          echeanciers: echs,
          montant: echs.reduce((acc, val) => acc + val.montantAPrendre, 0),
          style: calculateStyleCelluleEcheancierLigne(echs[0], this.data),
          avecFacturation: echs.find(e => e.factureId),
        };
      });
    },
  },
  methods: {
    formatDevise(value) {
      return formatDevise(value);
    },
    actionOnClick(ech) {
      if (!ech.avecFacturation) return;
      if (ech.echeanciers.length > 1) {
        this.echeanciersSelected = ech.echeanciers;
        this.afficherListeEcheancier = true;
        return;
      }
      const echeancier = ech.echeanciers[0];
      const routeData = this.$router.resolve({
        name: 'c.bodac.factures',
        params: { id: echeancier.factureId },
      });
      window.open(routeData.href, '_blank');
    },
  },
};
</script>
